import { Text, HStack } from '@chakra-ui/react';
import { weekLabel } from '~/types/utilities';

export default function Week() {
  return (
    <HStack spacing={2}>
      {weekLabel.map(({ label, value }) => {
        return (
          <Text key={value} flex="1" textAlign="center">
            {label}
          </Text>
        );
      })}
    </HStack>
  );
}
